import React from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import CookieBanner from "@/components/layout/CookieBanner";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1" data-testid="main-content">
        {children}
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
